import { render, staticRenderFns } from "./SecuritySituationalAwareness.vue?vue&type=template&id=13fd97c2&scoped=true"
import script from "./SecuritySituationalAwareness.vue?vue&type=script&lang=js"
export * from "./SecuritySituationalAwareness.vue?vue&type=script&lang=js"
import style0 from "./SecuritySituationalAwareness.vue?vue&type=style&index=0&id=13fd97c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd97c2",
  null
  
)

export default component.exports